package com.devi3east.bashbuddy.common.service

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.exceptions.ForceUpdateRequiredException
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class AppConfigViewModel(
    private val repository: AppConfigRepository,
    private val versionCheckService: VersionCheckService
) : ViewModel() {

    private val _uiState =
        MutableStateFlow(AppConfigUiState())

    val uiState: StateFlow<AppConfigUiState> =
        _uiState.asStateFlow()

    fun loadConfig() {
        viewModelScope.launch {
            _uiState.update {
                it.copy(isLoading = true)
            }

            try {
                repository.getApiConfig()
                    .onSuccess { config ->
                        _uiState.update {
                            it.copy(
                                currentMobileVersion = config.currentMobileVersion,
                                minimumMobileVersion = config.minimumMobileVersion,
                                leaderboardPromotionEnabled = config.leaderboardPromotionEnabled,
                                isLoading = false
                            )
                        }

                        ForceUpdateManager.set(
                            versionCheckService.requiresUpdate(config)
                        )
                    }
                    .onFailure { error ->
                        if (error is ForceUpdateRequiredException) {
                            ForceUpdateManager.enable()
                        }

                        _uiState.update {
                            it.copy(
                                isLoading = false,
                                leaderboardPromotionEnabled = false
                            )
                        }
                    }
            } catch (e: Exception) {
                if (e is ForceUpdateRequiredException) {
                    ForceUpdateManager.enable()
                }

                _uiState.update {
                    it.copy(
                        isLoading = false,
                        leaderboardPromotionEnabled = false
                    )
                }
            }
        }
    }
}